// extracted by mini-css-extract-plugin
module.exports = {"GalleryBanner":"GalleryBanner-module__GalleryBanner___2sANa"};